'use client';

import Link from '@/components/common/Link';

const ProTermsConditionModal = () => (
  <div>
    <p>
      The SITKA Pro Program is a private contract between you and W. L. Gore & Associates, doing
      business as SITKA, relating to the purchase of SITKA® Gear. Please read the following rules
      and guidelines for participation before applying:
    </p>
    <ol className="list-decimal m-5">
      <li className="my-5">
        CONFIDENTIAL Program Terms.
        <ol className="mx-3 list-[lower-alpha]" type="a">
          <li>Your Pro Program benefits are confidential and unique to you..</li>
        </ol>
      </li>
      <li className="my-5">
        PRO PROGRAM BENEFITS ARE ONLY AVAILABLE FOR USE AT
        <Link href="/" className="underline cursor-pointer text-blue-600 font-semibold">
          {' '}
          WWW.SITKAGEAR.COM
        </Link>
        .
        <ol className="mx-3 list-[lower-alpha]" type="a">
          <li>
            Respect our relationship with SITKA Gear Dealers/Retailers.
            <ol className="mx-3 list-[lower-roman]" type="i">
              <li>Do not discuss your Pro Program details.</li>
              <li>
                Please refrain from asking retailers for gear advice and or trying on gear at
                retail locations before making your online purchase.
              </li>
              <li>
                If you have questions about fit, feel, or function, call our Customer Service Team
                at:
                <span className="underline cursor-pointer text-blue-600 font-semibold">
                  {' '}
                  <a href="tel:877-748-5247">877-748-5247</a>
                </span>
              </li>
            </ol>
          </li>
          <li>
            Pro Program purchases are strictly for your personal use only. Refer your family,
            friends, and clients to a local dealer or to
            {' '}
            <Link className="underline cursor-pointer text-blue-600 font-semibold" href="/">
              {' '}
              WWW.SITKAGEAR.COM
            </Link>
            .
          </li>
        </ol>
      </li>
      <li className="my-5">
        NO RESALE – The reselling of SITKA® Gear purchased via the Pro Program is prohibited.
        <ol className="mx-3 list-[lower-alpha]" type="a">
          <li>
            We are happy to facilitate a Refund or Exchange at:
            {' '}
            <Link href="/returns" className="underline cursor-pointer text-blue-600 font-semibold">
              sitkagear.com/returns.
            </Link>
          </li>
        </ol>
      </li>
      <li className="my-5">
        NO BACKORDERS - Product is subject to availability.
        <ol className="mx-3 list-[lower-alpha]" type="a">
          <li>No Pro Program benefits on backorders are allowed.</li>
          <li>Pro Program discount may not apply to all products.</li>
        </ol>
        {' '}
      </li>
      <li className="my-5">
        RENEWAL – Accounts may require renewal.
        <ol className="mx-3 list-[lower-alpha]" type="a">
          <li>
            SITKA Pro Accounts will remain active for a period of time defined by SITKA Gear and are subject to
            change without notice.
          </li>
        </ol>
        {' '}
      </li>
      <li className="my-5">
        REQUIREMENTS  – Marketing Communication Enrollment.
        <ol className="mx-3 list-[lower-alpha]" type="a">
          <li>
            To remain enrolled in the SITKA Pro Program, you must be subscribed to receive all
            email and SMS communications.
          </li>
          <li>
            If you unsubscribe from marketing communications, your Pro membership may be revoked.
          </li>
        </ol>
        {' '}
      </li>
      <li className="my-5">
        PLEASE NOTE – Eligibility and Pro Program terms are subject to change without notice.
      </li>
    </ol>
    <p>
      Your participation in the SITKA Gear Pro Program is at SITKA’s sole discretion. If SITKA is
      notified of your abuse of any Pro Program terms in any way, you will automatically be
      removed from the Pro Program indefinitely.
    </p>
  </div>
);

export default ProTermsConditionModal;
